{
    "up.common.cancel": "取消",
    "up.common.confirm": "確定",
    "up.common.start": "開始",
    "up.common.end": "結束",
    "up.common.stop": "停止",
    "up.common.copy": "複製",
    "up.common.none": "暫無",
    "up.common.tip": "提示",
    "up.common.success": "成功",
    "up.common.fail": "失敗",
    "up.common.close": "關閉",
    "up.common.preview": "預覽",
    "up.common.re-select": "重選",
    "up.common.rotate": "旋轉",
    "up.common.pleaseChoose": "請選擇",
    "up.common.loading": "加載中",
    "up.common.loading2": "正在加載",
    "up.common.inOperation": "操作中",
    "up.common.settings": "設置",
    "up.common.retry": "重試",
    "up.common.search": "搜索",
    "up.common.more": "更多",
    "up.common.video": "視頻",
    "up.common.file": "文件",
    "up.week.one": "一",
    "up.week.two": "二",
    "up.week.three": "三",
    "up.week.four": "四",
    "up.week.five": "五",
    "up.week.six": "六",
    "up.week.seven": "日",
    "up.barcode.error": "生成條碼失敗",
    "up.calendar.chooseDates": "日期選擇",
    "up.calendar.disabled": "該日期已禁用",
    "up.calendar.daysExceed": "選擇天數不能超過{days}天",
    "up.cityLocate.locateCity": "定位城市",
    "up.cityLocate.fail": "定位失敗，請點擊重試。",
    "up.cityLocate.locating": "定位中",
    "up.code.send": "獲取驗證碼",
    "up.code.resendAfter": "X秒重新獲取",
    "up.code.resend": "重新獲取",
    "up.cropper.emptyWidhtOrHeight": "裁剪框的寬或高沒有設置",
    "up.empty.car": "購物車為空",
    "up.empty.page": "頁面不存在",
    "up.empty.search": "沒有搜索結果",
    "up.empty.address": "沒有收貨地址",
    "up.empty.wifi": "沒有WiFi",
    "up.empty.order": "訂單為空",
    "up.empty.coupon": "沒有優惠券",
    "up.empty.favor": "暫無收藏",
    "up.empty.permission": "無權限",
    "up.empty.history": "無歷史記錄",
    "up.empty.news": "無新聞列表",
    "up.empty.message": "消息列表為空",
    "up.empty.list": "列表為空",
    "up.empty.data": "數據為空",
    "up.empty.comment": "暫無評論",
    "up.link.copyed": "鏈接已複製，請在瀏覽器打開",
    "up.loadmoe.loadmore": "加載更多",
    "up.loadmoe.nomore": "沒有更多了",
    "up.noNetwork.text": "哎呀，網絡信號丟失",
    "up.noNetwork.pleaseCheck": "請檢查網絡，或前往",
    "up.noNetwork.connect": "網絡已連接",
    "up.noNetwork.disconnect": "無網絡連接",
    "up.pagination.previous": "上一頁",
    "up.pagination.next": "下一頁",
    "up.pullRefresh.pull": "下拉刷新",
    "up.pullRefresh.release": "釋放刷新",
    "up.pullRefresh.refreshing": "正在刷新",
    "up.readMore.expand": "展開閱讀全文",
    "up.readMore.fold": "收起",
    "up.search.placeholder": "請輸入關鍵字",
    "up.signature.penSize": "筆畫大小",
    "up.signature.penColor": "筆畫顏色",
    "up.upload.sizeExceed": "超過大小限制",
    "up.upload.uploading": "上傳中",
    "up.upload.previewImageFail": "預覽圖片失敗",
    "up.upload.previewVideoFail": "預覽視頻失敗",
    "up.goodsSku.stock": "庫存",
    "up.goodsSku.price": "價格",
    "up.goodsSku.amount": "件",
    "up.goodsSku.choosed": "已選",
    "up.goodsSku.buyAmount": "購買數量"
}
